// round10 B5 (결정 D10=B) — 한국 전화번호 자동 하이픈 포맷(길이/prefix 분기).
// 휴대폰(010 등) 3-4-4 + 서울 02(2자리 지역) + 그 외 3자리 지역번호를 모두 대응.
// 숫자만 추출하므로 IME 조합 잔재도 제거된다(B6 버그와 무관). 표시/저장은 하이픈
// 포함. 입력 중 매 키 재포맷이라 커서는 끝으로 가나, 좌→우 append 실사용엔 무해.
export function formatKoreanPhone(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (!d) return '';

  // 서울 지역번호 02 (지역번호 2자리)
  if (d.startsWith('02')) {
    if (d.length <= 2) return d;
    // 02-nnn-nnnn(9자리) / 02-nnnn-nnnn(10자리). 중간부는 총길이가 10일 때만 4자리.
    const midLen = d.length >= 10 ? 4 : 3;
    if (d.length <= 2 + midLen) return `${d.slice(0, 2)}-${d.slice(2)}`;
    return `${d.slice(0, 2)}-${d.slice(2, 2 + midLen)}-${d.slice(2 + midLen)}`;
  }

  // 그 외: 휴대폰(01x)은 항상 3-4-4, 3자리 지역번호(031 등)는 3-3-4(10자리).
  // 휴대폰은 입력 중(7자리)에도 중간부를 4자리로 채워야 '010-1234'가 된다.
  if (d.length <= 3) return d;
  const midLen = d.startsWith('01') || d.length >= 11 ? 4 : 3;
  if (d.length <= 3 + midLen) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 3 + midLen)}-${d.slice(3 + midLen)}`;
}
